module.exports = __webpack_public_path__ + "img/pepicons-pop-pen.9816fe61.svg";